@if (reviewAccessBlocked) {
  <main class="review-access" aria-labelledby="review-access-title">
    <section class="review-access__panel">
      <p class="review-access__eyebrow">Accès de revue</p>
      <h1 id="review-access-title">Code d’accès requis</h1>
      <p>
        Cette version contient du contenu en cours de validation. Le code d’accès est réservé aux
        personnes autorisées.
      </p>
      <p class="review-access__thanks">
        Merci à toutes les personnes qui prennent le temps de relire et de valider ce contenu.
      </p>

      @if (!reviewAccessCodeConfigured) {
        <p class="review-access__notice" role="alert">
          L’accès de revue est temporairement fermé. Le code n’est pas configuré.
        </p>
      } @else {
        <form novalidate (submit)="submitReviewAccess($event)">
          <label for="review-access-code">Code d’accès</label>
          <input
            name="review-access-code"
            id="review-access-code"
            type="text"
            inputmode="text"
            autocomplete="one-time-code"
            autocapitalize="off"
            autocorrect="off"
            spellcheck="false"
            enterkeyhint="go"
            [value]="reviewAccessInput"
            (input)="setReviewAccessInput($event)"
          />
          @if (reviewAccessError) {
            <p class="review-access__error" role="alert">Code incorrect. Vérifie le code fourni.</p>
          }
          <button type="submit" [disabled]="reviewAccessInput.length === 0">
            Entrer dans la revue
          </button>
        </form>
      }
    </section>
  </main>
} @else {
  <router-outlet />
}
